import { createReducer, on } from '@ngrx/store';

import * as ProductActions from './product.actions';
import { Product } from '../../../core/domain/product/product';
import { IFormMode } from '../../types/IFormMode';

export interface ProductState {
  isModalOpen: boolean;
  formMode?: IFormMode;
  openedProduct?: Product;

  products: Product[];
}

export const initialState: ProductState = {
  isModalOpen: false,
  formMode: undefined,
  openedProduct: undefined,

  products: [],
};

export const productReducer = createReducer(
  initialState,

  on(ProductActions.openProductModal, (state, action) => ({
    ...state,
    isModalOpen: true,
    formMode: action.mode,
    openedProduct: action.product || undefined,
  })),
  on(ProductActions.closeProductModal, (state) => ({
    ...state,
    isModalOpen: false,
    formMode: undefined,
    openedProduct: undefined,
  })),

  on(ProductActions.loadProducts, (state, action) => ({
    ...state,
    products: action.products,
  })),

  on(ProductActions.createProduct, (state, action) => ({
    ...state,
    products: [...state.products, action.product],
  })),
  on(ProductActions.updateProduct, (state, action) => ({
    ...state,
    products: state.products.map((product) =>
      product.id === action.product.id ? action.product : product
    ),
  })),
  on(ProductActions.deleteProduct, (state, action) => ({
    ...state,
    products: state.products.filter(
      (product) => product.id !== action.productId
    ),
  }))
);
